module.exports = __webpack_public_path__ + "static/media/instruction_for_calling_tl.aa3550ff.png";